(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),s=o(c),f=n(8),d=o(f),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded",throttleDelay:99,debounceDelay:50,disableMutationObserver:!1},j=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,x),(0,b.default)(w,x.once),w},O=function(){w=(0,h.default)(),j()},M=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},S=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},_=function(e){x=i(x,e),w=(0,h.default)();var t=document.all&&!window.atob;return S(x.disable)||t?M():(x.disableMutationObserver||d.default.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),x.disableMutationObserver=!0),document.querySelector("body").setAttribute("data-aos-easing",x.easing),document.querySelector("body").setAttribute("data-aos-duration",x.duration),document.querySelector("body").setAttribute("data-aos-delay",x.delay),"DOMContentLoaded"===x.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?j(!0):"load"===x.startEvent?window.addEventListener(x.startEvent,function(){j(!0)}):document.addEventListener(x.startEvent,function(){j(!0)}),window.addEventListener("resize",(0,s.default)(j,x.debounceDelay,!0)),window.addEventListener("orientationchange",(0,s.default)(j,x.debounceDelay,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,x.once)},x.throttleDelay)),x.disableMutationObserver||d.default.ready("[data-aos]",O),w)};e.exports={init:_,refresh:j,refreshHard:O}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(f,t),M?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return S?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||S&&o>=y}function f(){var e=O();return c(e)?d(e):void(h=setTimeout(f,a(e)))}function d(e){return h=void 0,_&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(f,t),o(w)}return void 0===h&&(h=setTimeout(f,t)),g}var b,v,y,g,h,w,k=0,M=!1,S=!1,_=!0;if("function"!=typeof e)throw new TypeError(s);return t=u(t)||0,i(n)&&(M=!!n.leading,S="maxWait"in n,y=S?x(u(n.maxWait)||0,t):y,_="trailing"in n?!!n.trailing:_),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(s);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return f;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?f:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s="Expected a function",f=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(f,t),M?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return S?x(i,y-o):i}function s(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||S&&o>=y}function f(){var e=j();return s(e)?d(e):void(h=setTimeout(f,u(e)))}function d(e){return h=void 0,_&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=s(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(f,t),i(w)}return void 0===h&&(h=setTimeout(f,t)),g}var b,v,y,g,h,w,O=0,M=!1,S=!1,_=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(M=!!n.leading,S="maxWait"in n,y=S?k(a(n.maxWait)||0,t):y,_="trailing"in n?!!n.trailing:_),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==f}function a(e){if("number"==typeof e)return e;if(r(e))return s;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?s:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",s=NaN,f="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e){var t=void 0,o=void 0,i=void 0;for(t=0;t<e.length;t+=1){if(o=e[t],o.dataset&&o.dataset.aos)return!0;if(i=o.children&&n(o.children))return!0}return!1}function o(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}function i(){return!!o()}function r(e,t){var n=window.document,i=o(),r=new i(a);u=t,r.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}function a(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),o=Array.prototype.slice.call(e.removedNodes),i=t.concat(o);if(n(i))return u()})}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){};t.default={isSupported:i,ready:r}},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,s=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new s},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){return e=e||document.querySelectorAll("[data-aos]"),Array.prototype.map.call(e,function(e){return{node:e}})};t.default=n}])});
},{}],2:[function(require,module,exports){
"use strict";

var _components = require("./components");

var document = window.document;
document.addEventListener('DOMContentLoaded', function () {
  (function () {
    _components.header.init();

    _components.slider.init();

    _components.dropdown.init();

    _components.subnavigation.init(); // filter.init();


    _components.layout.init();
  })();
});

},{"./components":5}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var dropdown = function () {
  var dropdownComponents = document.querySelectorAll('.dropdown');

  var onToggleDropdown = function onToggleDropdown() {
    dropdownComponents.forEach(function (dropdownComponent) {
      var dropdownList = dropdownComponent.querySelector('.dropdown-list');
      var dropdownTrigger = dropdownComponent.querySelector('.dropdown-trigger');
      var selectedCountry = dropdownComponent.querySelector('.default-country');
      var selectedPage = '';
      dropdownTrigger.addEventListener('click', function (event) {
        event.stopPropagation();
        dropdownList.classList.toggle('dropdown-list--active');
        dropdownTrigger.classList.toggle('dropdown-trigger--active');
      });
      document.addEventListener('click', function (event) {
        if (!dropdownComponent.contains(event.target)) {
          dropdownList.classList.remove('dropdown-list--active');
          dropdownTrigger.classList.remove('dropdown-trigger--active');
        }
      });
      var countryWrappers = dropdownList.querySelectorAll('.country-wrapper');
      countryWrappers.forEach(function (countryWrapper, index) {
        var countryItem = countryWrapper.querySelector('.country');
        var countryPage = countryItem.getAttribute('data-country-page');
        var countryName = countryItem.getAttribute('data-country-name');
        countryWrapper.addEventListener('click', function () {
          countryWrappers.forEach(function (wrapper) {
            return wrapper.classList.remove('country-wrapper--active');
          });
          countryWrapper.classList.add('country-wrapper--active');
          selectedCountry.textContent = countryName;
          selectedPage = countryPage;
        });

        if (index === 0) {
          countryWrapper.classList.add('country-wrapper--active');
          selectedCountry.textContent = countryName;
          selectedPage = countryPage;
        }
      });
      var button = dropdownComponent.querySelector('.dropdown-button');
      button.addEventListener('click', function () {
        if (selectedPage) {
          window.location.href = selectedPage;
        }
      });
    });
  };

  var init = function init() {
    onToggleDropdown();
  };

  return {
    init: init,
    dropdownComponents: dropdownComponents
  };
}();

var _default = exports["default"] = dropdown;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var header = function () {
  var header = document.getElementById('header');
  var mobileNavigation = header.querySelector('.m-header__navigation-mobile');
  var openMenuButton = header.querySelector('.hamburger');
  var closeMenuButton = header.querySelector('.cross');
  var languageButton = header.querySelector('.globe');
  var languageMenu = header.querySelector('.language-menu');
  var languageMenuMobile = header.querySelector('.m-header__navigation-mobile-language');
  var overlay = document.querySelector(".body-overlay"); // DESKTOP NAVIGATION 

  var onHoverItem = function onHoverItem() {
    var menuItems = header.querySelectorAll('.m-header__navigation--list');
    var currentSubmenu = null;
    var timer;
    menuItems === null || menuItems === void 0 || menuItems.forEach(function (item) {
      var subPages = item === null || item === void 0 ? void 0 : item.querySelector('.subpages-container');
      var subMenuItems = item === null || item === void 0 ? void 0 : item.querySelectorAll('.menu-item');
      item === null || item === void 0 || item.addEventListener("mouseenter", function () {
        clearTimeout(timer);

        if (currentSubmenu) {
          currentSubmenu.classList.remove("hovered");
        }

        subPages === null || subPages === void 0 || subPages.classList.add("hovered");
        overlay.classList.add("visible");
        currentSubmenu = subPages;
      });
      item === null || item === void 0 || item.addEventListener("mouseleave", function () {
        timer = setTimeout(function () {
          subPages === null || subPages === void 0 || subPages.classList.remove("hovered");
          overlay.classList.remove("visible");
        }, 200);
      });
      subPages === null || subPages === void 0 || subPages.addEventListener("mouseenter", function () {
        clearTimeout(timer);
      });
      subMenuItems === null || subMenuItems === void 0 || subMenuItems.forEach(function (item) {
        item === null || item === void 0 || item.addEventListener("mouseenter", function () {
          subMenuItems.forEach(function (otherItem) {
            if (otherItem !== item) {
              otherItem.classList.add("not-active");
            }
          });
        });
        item === null || item === void 0 || item.addEventListener("mouseleave", function () {
          subMenuItems.forEach(function (otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove("not-active");
            }
          });
        });
      });
    });
  };

  var onHoverLanguageButton = function onHoverLanguageButton() {
    var languagePages = languageMenu.querySelector('.language-pages');
    var languageItems = languagePages.querySelectorAll('.language-page'); // const languageSelector = languageMenu.querySelector('.language-selector')
    // const languages = languageSelector.querySelectorAll('.language')

    var languageSubmenu = null;
    var languageTimer;
    languageButton === null || languageButton === void 0 || languageButton.addEventListener("mouseenter", function () {
      clearTimeout(languageTimer);

      if (languageSubmenu) {
        languageSubmenu.classList.remove("hovered");
      }

      languageMenu === null || languageMenu === void 0 || languageMenu.classList.add("hovered");
      overlay.classList.add("visible");
      languageSubmenu = languageMenu;
    });
    languageButton === null || languageButton === void 0 || languageButton.addEventListener("mouseleave", function () {
      languageTimer = setTimeout(function () {
        languageMenu === null || languageMenu === void 0 || languageMenu.classList.remove("hovered");
        overlay.classList.remove("visible");
      }, 200);
    });
    languageMenu === null || languageMenu === void 0 || languageMenu.addEventListener("mouseenter", function () {
      clearTimeout(languageTimer);
    });
    languageMenu === null || languageMenu === void 0 || languageMenu.addEventListener("mouseleave", function () {
      languageTimer = setTimeout(function () {
        languageMenu === null || languageMenu === void 0 || languageMenu.classList.remove("hovered");
      }, 200);
    });
    languageItems === null || languageItems === void 0 || languageItems.forEach(function (item) {
      item === null || item === void 0 || item.addEventListener("mouseenter", function () {
        languageItems.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.classList.add("not-active");
          }
        });
      });
      item === null || item === void 0 || item.addEventListener("mouseleave", function () {
        languageItems.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.classList.remove("not-active");
          }
        });
      });
    }); // languages?.forEach((item) => {
    //     item?.addEventListener("mouseenter", () => {
    //         languages.forEach((otherItem) => {
    //             if (otherItem !== item) {
    //                 otherItem.classList.add("not-active")
    //             }
    //         })
    //     })
    //     item?.addEventListener("mouseleave", () => {
    //         languages.forEach((otherItem) => {
    //             if (otherItem !== item) {
    //                 otherItem.classList.remove("not-active")
    //             }
    //         })
    //     })
    // })
  }; // DESKTOP NAVIGATION STICKY


  var shadowHeader = function shadowHeader() {
    var lastScrollTop = 0;
    window.addEventListener("scroll", function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;

      if (st > 1) {
        header.classList.add("header-shadow");
        mobileNavigation.classList.add("header-shadow");
      }

      if (st < 1) {
        header.classList.remove("header-shadow");
        mobileNavigation.classList.remove("header-shadow");
      }
    }, false);
  }; // MOBILE NAVIGATION


  var onToggleHamburger = function onToggleHamburger() {
    openMenuButton === null || openMenuButton === void 0 || openMenuButton.addEventListener("click", function () {
      mobileNavigation.classList.toggle("m-header__navigation-mobile--active");
      openMenuButton.classList.toggle("hamburger--inactive");
      closeMenuButton.classList.toggle("cross--active");
      languageButton.classList.toggle("globe--inactive");

      if (languageMenuMobile !== null && languageMenuMobile !== void 0 && languageMenuMobile.classList.contains("m-header__navigation-mobile-language--active")) {
        languageMenuMobile.classList.remove("m-header__navigation-mobile-language--active");
      }
    });
    closeMenuButton === null || closeMenuButton === void 0 || closeMenuButton.addEventListener("click", function () {
      mobileNavigation.classList.toggle("m-header__navigation-mobile--active");
      openMenuButton.classList.toggle("hamburger--inactive");
      closeMenuButton.classList.toggle("cross--active");
      languageButton.classList.toggle("globe--inactive");
    });
  };

  var onToggleChevron = function onToggleChevron() {
    mobileNavigation === null || mobileNavigation === void 0 || mobileNavigation.addEventListener('click', function (event) {
      var clickedItem = event.target.closest('.m-header__navigation-mobile--list');
      if (!clickedItem) return;
      var subMenuButton = clickedItem.querySelector('.chevron');
      var subMenu = clickedItem.querySelector('.submenu');
      subMenu.classList.toggle('submenu--active');
      subMenuButton.classList.toggle('chevron--rotate');
    });
  };

  var openMobileNavigation = function openMobileNavigation() {
    openMenuButton === null || openMenuButton === void 0 || openMenuButton.addEventListener('click', function () {
      document.body.style.overflow = 'hidden';
    });
    languageButton === null || languageButton === void 0 || languageButton.addEventListener('click', function () {
      document.body.style.overflow = 'hidden';
    });
  };

  var closeMobileNavigation = function closeMobileNavigation() {
    closeMenuButton === null || closeMenuButton === void 0 || closeMenuButton.addEventListener('click', function () {
      document.body.style.overflow = '';
    });
    languageButton === null || languageButton === void 0 || languageButton.addEventListener('click', function () {
      document.body.style.overflow = 'hidden';
    });
  };

  var onToggleLanguageButton = function onToggleLanguageButton() {
    languageButton === null || languageButton === void 0 || languageButton.addEventListener("click", function () {
      if (window.innerWidth < 1200) {
        languageMenuMobile.classList.toggle('m-header__navigation-mobile-language--active');
      }
    });
  }; // LANGUAGE SETTINGS
  // const onToggleLanguage = () => {
  //     const languageSelectors = document.querySelectorAll('.languageSelector')
  //     const htmlElement = document.documentElement
  //     languageSelectors?.forEach(language => {
  //         language?.addEventListener("click", () => {
  //             const selectedLang = language.getAttribute('data-lang')
  //             htmlElement.setAttribute("lang", selectedLang)
  //         })
  //     })
  // }
  // const onToggleMobileLanguage = () => {
  //     const mobileLanguageSelectors = document.querySelectorAll('.mobileLanguageSelector')
  //     const htmlElement = document.documentElement
  //     mobileLanguageSelectors?.forEach(language => {
  //         language?.addEventListener("click", () => {
  //             const selectedLang = language.getAttribute('data-lang')
  //             htmlElement.setAttribute("lang", selectedLang)
  //             languageMenuMobile.classList.remove("m-header__navigation-mobile-language--active")
  //         })
  //     })
  // }


  var init = function init() {
    onHoverItem();
    onToggleHamburger();
    onToggleChevron();
    openMobileNavigation();
    closeMobileNavigation();
    onHoverLanguageButton();
    onToggleLanguageButton(); // onToggleLanguage()
    // onToggleMobileLanguage()

    shadowHeader();
  };

  return {
    init: init,
    header: header,
    mobileNavigation: mobileNavigation,
    openMenuButton: openMenuButton,
    closeMenuButton: closeMenuButton,
    languageButton: languageButton,
    languageMenu: languageMenu
  };
}();

var _default = exports["default"] = header;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "dropdown", {
  enumerable: true,
  get: function get() {
    return _dropdown["default"];
  }
});
Object.defineProperty(exports, "header", {
  enumerable: true,
  get: function get() {
    return _header["default"];
  }
});
Object.defineProperty(exports, "layout", {
  enumerable: true,
  get: function get() {
    return _layout["default"];
  }
});
Object.defineProperty(exports, "slider", {
  enumerable: true,
  get: function get() {
    return _slider["default"];
  }
});
Object.defineProperty(exports, "subnavigation", {
  enumerable: true,
  get: function get() {
    return _subnavigation["default"];
  }
});

var _header = _interopRequireDefault(require("./header"));

var _slider = _interopRequireDefault(require("./slider"));

var _dropdown = _interopRequireDefault(require("./dropdown"));

var _subnavigation = _interopRequireDefault(require("./subnavigation"));

var _layout = _interopRequireDefault(require("./layout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

},{"./dropdown":3,"./header":4,"./layout":6,"./slider":7,"./subnavigation":8}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _aos = _interopRequireDefault(require("aos"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var layout = function () {
  var init = function init() {
    _aos["default"].init({
      duration: '800',
      once: true
    });
  };

  return {
    init: init
  };
}();

var _default = exports["default"] = layout;

},{"aos":1}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var slider = function () {
  var testimonialsSlider = function testimonialsSlider() {
    var logos = document.querySelectorAll('.pagination-logo');
    var slides = document.querySelectorAll('.swiper-slide');

    if (slides) {
      var testimonials = new Swiper('.m-testimonials .swiper-container', {
        effect: 'fade',
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        slidesPerView: 1,
        loop: true,
        clickable: true,
        pagination: {
          el: '.m-testimonials .swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            return '<div class="custom ' + className + '">' + logos[index].outerHTML + '</div>';
          }
        }
      });
    }
  };

  var cardSlider = function cardSlider() {
    var _document;

    var cardSliders = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelectorAll(".card-slider-content");
    cardSliders.forEach(function (cardSlider, index) {
      var imageItems = cardSlider.querySelectorAll("img");
      var imageLength = imageItems.length;

      if (index == 0) {
        var scrolling = function scrolling() {
          var rightMarker = imageItemsAll[imageLength].getBoundingClientRect().left;

          if (rightMarker <= leftMarker) {
            clearInterval(autoScroll);
            cardSlider.style.animation = 'none';
            cardSlider.style.transition = '0s';
            cardSlider.style.transform = 'translateX(0)';
            leftMarker = cardSlider.querySelector(':first-child').getBoundingClientRect().left;
            autoScroll = setInterval(scrolling);
          }

          cardSlider.style.animation = 'scrolling-cards 50s linear infinite';
        };

        for (var j = 0; j < 2; j++) {
          for (var i = 0; i < imageLength; i++) {
            cardSlider.insertAdjacentHTML('beforeend', imageItems[i].outerHTML);
          }
        }

        var leftMarker = cardSlider.querySelector(':first-child').getBoundingClientRect().left;
        var autoScroll = setInterval(scrolling);
        var imageItemsAll = cardSlider.querySelectorAll("img");
      } else {
        var _scrolling = function _scrolling() {
          var leftMarker = _imageItemsAll[imageLength * 2 - 1].getBoundingClientRect().right;

          if (leftMarker >= rightMarker) {
            clearInterval(_autoScroll);
            cardSlider.style.animation = 'none';
            cardSlider.style.transition = '0s';
            cardSlider.style.transform = 'translateX(0)';
            rightMarker = _imageItemsAll[_imageItemsAll.length - 1].getBoundingClientRect().right;
            _autoScroll = setInterval(_scrolling);
          }

          cardSlider.style.animation = 'scrolling-cards-reversed 50s linear infinite';
        };

        for (var _j = 0; _j < 2; _j++) {
          for (var _i = imageLength - 1; _i >= 0; _i--) {
            cardSlider.insertAdjacentHTML('afterbegin', imageItems[_i].outerHTML);
          }
        }

        var _imageItemsAll = cardSlider.querySelectorAll("img");

        var rightMarker = _imageItemsAll[_imageItemsAll.length - 1].getBoundingClientRect().right;

        var _autoScroll = setInterval(_scrolling);
      }
    });
  };

  var logoSlider = function logoSlider() {
    var logosSliders = document.querySelectorAll('.m-logos__logos');
    var customerSliders = document.querySelectorAll('.m-customers__logos');

    if (customerSliders) {
      customerSliders.forEach(function (customerSlider) {
        var row = customerSlider.querySelector('.customer-logos-row');
        var rowWidth = row.offsetWidth;
        var windowWidth = window.innerWidth;
        var copiesNeeded = Math.ceil(windowWidth / rowWidth);
        var containerWidth = rowWidth * copiesNeeded;
        customerSlider.style.display = 'none';

        for (var i = 0; i < copiesNeeded; i++) {
          var copy = row.cloneNode(true);
          copy.style.width = "".concat(rowWidth, "px");
          customerSlider.appendChild(copy);
        }

        customerSlider.style.width = "".concat(containerWidth, "px");
        setTimeout(function () {
          customerSlider.style.display = '';
        }, 100);
      });
    }

    if (logosSliders) {
      logosSliders.forEach(function (logoSlider) {
        var row = logoSlider.querySelector('.logos-row');
        var rowWidth = row.offsetWidth;
        var windowWidth = window.innerWidth;
        var copiesNeeded = Math.ceil(windowWidth / rowWidth);
        var containerWidth = rowWidth * copiesNeeded;
        logoSlider.style.display = 'none';

        for (var i = 0; i < copiesNeeded; i++) {
          var copy = row.cloneNode(true);
          copy.style.width = "".concat(rowWidth, "px");
          logoSlider.appendChild(copy);
        }

        logoSlider.style.width = "".concat(containerWidth, "px");
        setTimeout(function () {
          logoSlider.style.display = '';
        }, 100);
      });
    }
  };

  var init = function init() {
    testimonialsSlider();
    cardSlider();
    logoSlider();
  };

  return {
    init: init
  };
}();

var _default = exports["default"] = slider;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var subnavigation = function (_document, _document2, _document3, _document4, _document5) {
  var headerM = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelector('#header');
  var subNavSection = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.querySelector('.m-subnavigation');
  var subNavContainer = (_document3 = document) === null || _document3 === void 0 ? void 0 : _document3.querySelector('.m-subnavigation-container');
  var subNavItems = subNavSection === null || subNavSection === void 0 ? void 0 : subNavSection.querySelectorAll('.subnavigation-item');
  var mobileSubNav = (_document4 = document) === null || _document4 === void 0 ? void 0 : _document4.querySelector('.subnav-mobile');
  var mobileSubNavList = mobileSubNav === null || mobileSubNav === void 0 ? void 0 : mobileSubNav.querySelector('.subnavigation-ul');
  var mobileSubNavItems = mobileSubNav === null || mobileSubNav === void 0 ? void 0 : mobileSubNav.querySelectorAll('.subnavigation-item-mobile');
  console.log("setting correct data-js-target for subnavigation"); // Find all 'a' elements with class 'subnavigation-item-link'

  var links = document.querySelectorAll('a.subnavigation-item-link');
  links.forEach(function (link) {
    // Get the corresponding section ID from the href attribute
    var sectionId = link.getAttribute('href').substring(1); // Remove '#'

    var section = document.getElementById(sectionId); // Check if the section exists and has class names

    if (section && section.classList.length > 0) {
      // Get the first class of the section
      var firstClass = section.classList[0]; // Find the parent 'section' that contains the 'ul'

      var parentSection = link.closest('section');

      if (parentSection) {
        // Set the 'data-js-target' attribute with the first class of the target section
        parentSection.setAttribute('data-js-target', firstClass);
      }
    }
  });
  var targetSectionName = subNavSection === null || subNavSection === void 0 ? void 0 : subNavSection.dataset.jsTarget;
  console.log("reading data-js-target for subnavigation: ", targetSectionName);
  var targetSections = (_document5 = document) === null || _document5 === void 0 ? void 0 : _document5.querySelectorAll('.' + targetSectionName);

  var checkScrollPosition = function checkScrollPosition() {
    window.addEventListener("scroll", function () {
      if (!mobileSubNavList.className.includes("isExpanded")) {
        var subNavTop = subNavSection.getBoundingClientRect().top + window.scrollY;
        var topHeight = window.scrollY + headerM.clientHeight;

        if (topHeight >= subNavTop) {
          subNavContainer.classList.add('in-view');
          subNavSection.classList.add('border');
          headerM.classList.remove('header-shadow');
        } else {
          subNavContainer.classList.remove('in-view');
          subNavSection.classList.remove('border');
          headerM.classList.add('header-shadow');
        }

        targetSections.forEach(function (section) {
          var sectionTop = section.getBoundingClientRect().top + window.scrollY;
          var sectionBottom = sectionTop + section.clientHeight;
          var topDist = scrollY + 128;

          if (Math.round(sectionTop) <= Math.round(topDist) && Math.round(sectionBottom) >= Math.round(topDist)) {
            subNavItems.forEach(function (item) {
              if ((item === null || item === void 0 ? void 0 : item.dataset.jsTargetItem) == section.id) {
                item.className == "active" || item.classList.add("active");
              } else {
                item.classList.remove("active");
              }
            });
            mobileSubNavItems.forEach(function (item, index) {
              if ((item === null || item === void 0 ? void 0 : item.dataset.jsTargetItem) == section.id) {
                var transitionY = index * 50;
                mobileSubNavList.style.transform = "translateY(-" + transitionY + "px)";
              }
            });
          }
        });
      }
    });
  };

  var subNavDropdown = function subNavDropdown() {
    var mobileSubnavBtn = mobileSubNav === null || mobileSubNav === void 0 ? void 0 : mobileSubNav.querySelector('#subnav-dropdown-button');
    var subNavListHeight = mobileSubNavItems.length * 64;
    mobileSubnavBtn === null || mobileSubnavBtn === void 0 || mobileSubnavBtn.addEventListener("click", function (e) {
      e.preventDefault();

      if (mobileSubNavList.className.includes("isExpanded")) {
        mobileSubNav.style.maxHeight = "64px";
      } else {
        var _document6;

        (_document6 = document) === null || _document6 === void 0 || _document6.addEventListener('click', function (event) {
          if (!mobileSubNav.contains(event.target)) {
            mobileSubNav.style.maxHeight = "64px";
            mobileSubNavList.classList.remove("isExpanded");
          }
        });
        mobileSubNav.style.maxHeight = subNavListHeight + "px";
      }

      mobileSubNavList.classList.toggle("isExpanded");
    });
    var mobileSubNavItemLinks = mobileSubNavList.querySelectorAll(".subnavigation-item-link");
    mobileSubNavItemLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        document.getElementById(link.parentElement.dataset.jsTargetItem).scrollIntoView();
        setScrollMargin();

        if (mobileSubNavList.className.includes("isExpanded")) {
          mobileSubNavList.classList.remove("isExpanded");
          mobileSubNav.style.maxHeight = "64px";
        }
      });
    });
  };

  var setScrollMargin = function setScrollMargin() {
    var innerWidth = window.innerWidth;
    targetSections.forEach(function (section) {
      section.style.scrollMarginTop = innerWidth > 576 ? '100px' : '120px';
    });
  };

  var init = function init() {
    if (document.querySelectorAll('.m-subnavigation').length > 0) {
      setScrollMargin();
      checkScrollPosition();
      subNavDropdown();
    }
  };

  return {
    init: init
  };
}();

var _default = exports["default"] = subnavigation;

},{}]},{},[2]);
